import { em } from 'polished'
import styled from 'styled-components'

export const EarthImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: ${em(800)};
  height: ${em(450)};
  opacity: 0;
  transition: opacity 0.4s ease-in;
`
